import { createFetcher } from '../../Fetcher/Fetcher'
import {
  getBaseUrl,
  PAYMENT_ENDPOINT,
  BILLING_ENDPOINT,
  ADMIN_ENDPOINT,
} from '../../constant'

/**
 * For payments.
 * @Applications
 */
export default class Payment {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Payment(
        PAYMENT_ENDPOINT,
        BILLING_ENDPOINT,
        ADMIN_ENDPOINT,
        createFetcher()
      )
    }
    return this.instance
  }

  constructor(paymentEndPoint, billingEndPoint, adminEndPoint, fetcherObj) {
    this.paymentEndPoint = paymentEndPoint
    this.billingEndPoint = billingEndPoint
    this.adminEndPoint = adminEndPoint
    this.fetcher = fetcherObj
  }

  static get baseUrl() {
    return getBaseUrl()
  }

  async postPayment(reqData, resourceId) {
    const url = `${Payment.baseUrl + this.adminEndPoint}/${
      resourceId + this.paymentEndPoint
    }`
    const response = await this.fetcher.postData(url, reqData)
    return response?.data?.data
  }

  async getBillingLog(resourceId, transactionType, billingPageLimit, offset) {
    const url = `${Payment.baseUrl + this.adminEndPoint}/${
      resourceId + this.billingEndPoint
    }?transactionType=${transactionType}&limit=${billingPageLimit}&offset=${offset}`
    const response = await this.fetcher.getData(url)
    return response
  }
}
